// import { gsap } from 'gsap';

// import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
// gsap.registerPlugin(ScrollToPlugin);

// window.gsap = gsap;

// gsap.defaults({
// 	overwrite: 'auto',
// });

const HTML_CLASSLIST = document.documentElement.classList;

class ProjectApp {
	constructor() {
		// this.env = require('./utils/env').default;
		// this.utils = require('./utils/utils').default;
		this.classes = {
			// Signal: require('./classes/Signal').default,
		};
		this.modules = {
			ScrollTo: require('./modules/ScrollTo').default,
			Form: require('./modules/Form').default,
		};
		this.components = {
			Input: require('../../components/input/input').default,
			TechnologyCard:
				require('../../components/technology-card/technology-card').default,
			Popups: require('../../components/popups/popups').default,
			Header: require('../../components/header/header').default,
			Hero: require('../../components/hero/hero').default,
		};
		this.helpers = {};

		window.addEventListener('load', () => {
			HTML_CLASSLIST.remove('_loading');

			const inputs = document.querySelectorAll('.input');
			inputs.forEach((input) => new this.components.Input(input));
		});
	}
}

window.ProjectApp = new ProjectApp();
